<div class="banner" role="banner">
  <h1>{{ 'pick.player.leaderboard.title' | translate }}</h1>
</div>

<div class="container mt-4">
  <h4 class="text-center">{{ 'pick.player.leaderboard.title' | translate }}</h4>
  <fgb-leaderboard [toShow]="10"></fgb-leaderboard>
</div>
